import { render, staticRenderFns } from "./ProducerRevenue.vue?vue&type=template&id=3e169708&scoped=true&"
import script from "./ProducerRevenue.vue?vue&type=script&lang=js&"
export * from "./ProducerRevenue.vue?vue&type=script&lang=js&"
import style0 from "./ProducerRevenue.vue?vue&type=style&index=0&id=3e169708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e169708",
  null
  
)

export default component.exports